// =============================================================================
// Mega-dropdown — full-width nav panels (Our Products, Services).
// Desktop (≥xl): hover or click to open; a short grace timer lets the mouse
// bridge from the menu item to the panel without closing.
// Mobile (<xl): mega panels are hidden — the trigger expands the inline
// [data-mobile-dropdown] inside the drawer instead.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        const XL_MIN = 1280;
        const HOVER_DELAY = 150;
        let hoverTimer = null;

        const $megaTriggers = $('[data-mega-trigger]');
        const $megaItems    = $('[data-mega]');
        const $megaPanels   = $('[data-mega-panel]');

        if (!$megaTriggers.length) { return; }

        function isDesktop() { return window.innerWidth >= XL_MIN; }

        function closeAllMega() {
            $megaPanels.removeClass('is-open').attr('aria-hidden', 'true');
            $megaItems.removeClass('is-open');
            $megaTriggers.attr('aria-expanded', 'false');
        }

        function openMega(name) {
            clearTimeout(hoverTimer);
            closeAllMega();
            $('[data-mega-panel="' + name + '"]').addClass('is-open').attr('aria-hidden', 'false');
            $('[data-mega="' + name + '"]').addClass('is-open');
            $('[data-mega-trigger="' + name + '"]').attr('aria-expanded', 'true');
        }

        function deferClose() {
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(closeAllMega, HOVER_DELAY);
        }

        function cancelClose() {
            clearTimeout(hoverTimer);
        }

        $(document).on('click', '[data-mega-trigger]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const name = $(this).attr('data-mega-trigger');
            const $item = $(this).closest('[data-mega]');
            const wasOpen = $item.hasClass('is-open');

            closeAllMega();
            if (!wasOpen) { openMega(name); }
        });

        // Clicks inside the panel don't bubble to document close.
        $(document).on('click', '[data-mega-panel]', (e) => { e.stopPropagation(); });

        // Click a link inside a panel — close so the panel doesn't linger
        // while the next page loads.
        $(document).on('click', '[data-mega-panel] a', () => { closeAllMega(); });

        $(document).on('click', () => { closeAllMega(); });

        $megaItems.on('mouseenter', function () {
            if (!isDesktop()) { return; }
            openMega($(this).attr('data-mega'));
        });

        $megaItems.on('mouseleave', () => {
            if (!isDesktop()) { return; }
            deferClose();
        });

        $megaPanels.on('mouseenter', cancelClose);
        $megaPanels.on('mouseleave', () => {
            if (!isDesktop()) { return; }
            deferClose();
        });

        $(document).on('keydown', (e) => {
            if (e.key !== 'Escape') { return; }
            if (!$('.mega-dropdown.is-open').length) { return; }
            const $activeTrigger = $('[data-mega-trigger][aria-expanded="true"]');
            closeAllMega();
            $activeTrigger.trigger('focus');
        });

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(closeAllMega, 100);
        });
    });
})(jQuery);
